
/**
 *  Read More JS
 *  Truncates text via specfied character length with more/less actions.
 *  Maintains original format of pre truncated text.
 *  @author stephen scaff
 *  @todo   Add destroy method for ajaxed content support.
 *
 */
const ReadMore = (() => {
   let s;

   return {

     settings() {
       return {
         content: document.querySelectorAll('.js-read-more'),
         originalContentArr: [],
         truncatedContentArr: [],
         moreLink: "Read More",
         lessLink: "Read Less",
       }
     },

     init() {
       s = this.settings();
       this.bindEvents();
     },

     bindEvents() {
       ReadMore.truncateText();
     },

     /**
      * Count Words
      * Helper to handle word count.
      * @param {string} str - Target content string.
      */
     countWords(str) {
       return str.split(/\s+/).length;
     },

     /**
      * Ellpise Content
      * @param {string} str - content string.
      * @param {number} wordsNum - Number of words to show before truncation.
      */
     ellipseContent(str, wordsNum) {
       return str.split(/\s+/).slice(0, wordsNum).join(' ') + '...';
     },

     /**
      * Truncate Text
      * Truncate and ellipses contented content
      * based on specified word count.
      * Calls createLink() and handleClick() methods.
      */
     truncateText() {

       for (let i = 0; i < s.content.length; i++) {
         //console.log(s.content)
         const originalContent = s.content[i].innerHTML;
         const numberOfWords = s.content[i].dataset.rmWords;
         const truncateContent = ReadMore.ellipseContent(originalContent, numberOfWords);
         const originalContentWords = ReadMore.countWords(originalContent);

         s.originalContentArr.push(originalContent);
         s.truncatedContentArr.push(truncateContent);

         if (numberOfWords < originalContentWords) {
           s.content[i].innerHTML = s.truncatedContentArr[i];
           let self = i;
           ReadMore.createLink(self)
         }
       }
       ReadMore.handleClick(s.content);
     },

     /**
      * Create Link
      * Creates and Inserts Read More Link
      * @param {number} index - index reference of looped item
      */
     createLink(index) {
       const linkWrap = document.createElement('span');

       linkWrap.className = 'read-more__link-wrap';

       linkWrap.innerHTML = `<a id="read-more_${index}" class="read-more__link" style="cursor:pointer;">${s.moreLink}</a>`;

       // Inset created link
       s.content[index].parentNode.insertBefore(linkWrap, s.content[index].nextSibling);

     },

     /**
      * Handle Click
      * Toggle Click eve
      */
     handleClick(el) {
       const readMoreLink = document.querySelectorAll('.read-more__link');

       for (let j = 0, l = readMoreLink.length; j < l; j++) {

         readMoreLink[j].addEventListener('click', function() {

           const moreLinkID = this.getAttribute('id');
           let index = moreLinkID.split('_')[1];

           el[index].classList.toggle('is-expanded');

           if (this.dataset.clicked !== 'true') {
              el[index].innerHTML = s.originalContentArr[index];
              this.innerHTML = s.lessLink;
              this.dataset.clicked = true;
           } else {
             el[index].innerHTML = s.truncatedContentArr[index];
             this.innerHTML = s.moreLink;
             this.dataset.clicked = false;
           }
         });
       }
     },

     /**
      * Open All
      * Method to expand all instances on the page.
      */
     openAll() {
       const instances = document.querySelectorAll('.read-more__link');
         for (let i = 0; i < instances.length; i++) {
           content[i].innerHTML = s.truncatedContentArr[i];
           instances[i].innerHTML = s.moreLink;
         }
       }
     }
 })();


const items = document.querySelector("#section-header > div > div:nth-child(1) > nav > ul").children;

for (let i = 0;i < items.length;i++) {
    const item = items[i];
  if (item.ariaHasPopup) {
      item.classList.add('test')
    }
}

var button = document.querySelector('.read-more');

if (button) {
  button.addEventListener('click', function(event) {
    var span = document.querySelector('.show-more .more');
    span.classList.toggle('fade-in');
  });  
}


var showMoreCollections = document.querySelector('.show-more-collections');

if (showMoreCollections) {
  showMoreCollections.addEventListener('click', function(event) {
  const block = document.querySelector('#section-template--14208588283984__16375070728f6efa16 .CollectionList');
  block.classList.toggle('all');
});
}


document.addEventListener("DOMContentLoaded", () => {
	init_read_more();
	init_cross_sale_products();
	init_shipping_estimator_popup();
    setupCustomAnalytics();
    setupDiscount()
});

// Init read more functionality
function init_read_more() {
  const elem = document.querySelector('#shopify-section-template--14208588906576__163759931822cb5fa6 p');
  if (elem) {
    elem.classList.add('js-read-more');

    elem.setAttribute('data-rm-words', 18) 

    if (document.querySelector('.js-read-more')) {
      ReadMore.init();
    }
  }
}

// Init cross sale products
function init_cross_sale_products() {
  const btn_add_to_cart = document.querySelectorAll(".product_btn_add_to_cart");
  if (btn_add_to_cart) {
    const products_in_cart = [];
    jQuery.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
    }).then((data) => {
      data.items.forEach(function(item, i) {
        products_in_cart.push(item.id);
      });
      if (products_in_cart.length != 0) {
        btn_add_to_cart.forEach(function(item, i) {
          for (var x = 0; x < products_in_cart.length; x++) {
            if (btn_add_to_cart[i].closest('.ProductItem').getAttribute('data-id') == products_in_cart[x]) {
              if(btn_add_to_cart[i].classList.contains('product_btn_add_to_cart--small')) {
                btn_add_to_cart[i].innerHTML = "Remove";
              } else {
                btn_add_to_cart[i].innerHTML = "Remove from cart";
              }
              btn_add_to_cart[i].setAttribute("data_product_status", "Remove from cart");
            }
          }
        });
      }
    });
    btn_add_to_cart.forEach(function(item) {
      item.addEventListener("click", function(e) {
        if (item.getAttribute('data_product_status') == "Add to cart") {
          item.setAttribute('disabled', 'disabled');
          jQuery.ajax({
              type: "POST",
              url: "/cart/add.js",
              dataType: "json",
              data: {
                id: item.closest('.ProductItem').getAttribute('data-id'),
                quantity: 1,
              },
            }).then((data) => {
              item.setAttribute('disabled', '');
              if(item.classList.contains('product_btn_add_to_cart--small')) {
                item.innerHTML = "Remove";
              } else {
                item.innerHTML = "Remove from cart";
              }
              item.setAttribute("data_product_status", "Remove from cart");
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            });
        } else if (item.getAttribute('data_product_status') == "Remove from cart") {
          item.setAttribute('disabled', 'disabled');
          jQuery.ajax({
              type: "POST",
              url: "/cart/change.js",
              dataType: "json",
              data: {
                id: item.closest('.ProductItem').getAttribute('data-id'),
                quantity: 0,
              },
          }).then((data) => {
              item.setAttribute('disabled', '');
              if(item.classList.contains('product_btn_add_to_cart--small')) {
                item.innerHTML = "Add";
              } else {
                item.innerHTML = "Add to cart";
              }
              item.setAttribute("data_product_status", "Add to cart");
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          });
        }
      });
    });
  }

  const crossale_overlay_btn = document.querySelectorAll(".crossale_overlay_btn");
  if (crossale_overlay_btn) {
    crossale_overlay_btn.forEach(function(item) {
      item.addEventListener("click", function(e) {
        item.nextElementSibling.click();
      });
    });
  }
}

// Init shipping estimator popup
function init_shipping_estimator_popup() {
  const estimate_popup_btn = document.querySelector(".estimate-popup__btn");
  const estimate_popup_wrap = document.querySelector(".estimate-popup__wrap");
  const shipping_close_btn = document.querySelector(".shipping-close-btn");

  if (!estimate_popup_btn) return;

  if (estimate_popup_btn) {
    estimate_popup_btn.addEventListener("click", function(e) {
      estimate_popup_wrap.classList.toggle('estimate-popup__wrap--active');
      estimate_popup_btn.classList.toggle('estimate-popup__btn--active');
    });
    shipping_close_btn.addEventListener("click", function(e) {
      estimate_popup_wrap.classList.toggle('estimate-popup__wrap--active');
      estimate_popup_btn.classList.toggle('estimate-popup__btn--active');
    });
  }
  

  const popup_estimate_zip = document.querySelector("#popup_estimate_zip");
  const popup_estimate_btn = document.querySelector("#popup_estimate_btn");
  const popup_estimate_result = document.querySelector("#popup_estimate_result");
  const popup_estimate_price = Number(document.querySelector("#popup_estimate_price").textContent.slice(0, -2));
  const popup_estimate_result_wrap = document.querySelector("#popup_estimate_result_wrap");
  const popup_estimate_error = document.querySelector("#popup_estimate_error");

  if (popup_estimate_zip) {
      popup_estimate_btn.addEventListener("click", function(e) {
      if (90000 <= popup_estimate_zip.value  && popup_estimate_zip.value <= 99999) {
        calc_rates(popup_estimate_zip.value);
        popup_estimate_error.style.display = "none";
        popup_estimate_result_wrap.style.display = "block";
      } else {
        popup_estimate_result_wrap.style.display = "none";
        popup_estimate_error.style.display = "block";
      }
    });
  }

  function calc_rates(zip, callback) {
    var service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: ["Los Angeles, CA 90012 505 North Figueroa Street, USA"], // заменить адрес
        destinations: [`Los Angeles, ${zip}, USA`],
        travelMode: 'DRIVING',
        unitSystem: google.maps.UnitSystem.IMPERIAL,
      }, callback);
    function callback(response, status) {
      let value = Math.floor(parseInt(response.rows[0].elements[0].distance.value) / 1609.34);
      console.log(value);
      console.log(popup_estimate_price);
      var miles_value_price = 0;
      if (40 <= value && 400 <= popup_estimate_price) {
        miles_value_price = value * 2;
        window.rate = 'Standard Delivery Fee (40+ mi): $' + (miles_value_price).toFixed(2);
      } else if (20 <= value && value <= 40 && popup_estimate_price <= 399) {
        miles_value_price = value * 1.1;
        window.rate = 'Standard Delivery Fee (20-40 mi): $' + (miles_value_price).toFixed(2);
      } else if (10 <= value && value <= 20 && popup_estimate_price <= 399) {
        miles_value_price = value * 1;
        window.rate = 'Standard Delivery Fee (10-20 mi, up to $400): $' + (miles_value_price).toFixed(2);
      } else if (10 <= value && value <= 20 && 400 <= popup_estimate_price) {
        window.rate = 'Standard Delivery Fee (10-20 mi, $400+): $0';
      } else if (5 <= value && value <= 10 && popup_estimate_price <= 249) {
        miles_value_price = value * 1;
        window.rate = 'Standard Delivery Fee (5-10 mi, up to $250): $' + (miles_value_price).toFixed(2);
      } else if (5 <= value && value <= 10 && 250 <= popup_estimate_price) {
        window.rate = 'Standard Delivery Fee (5-10 mi, $250+): $0';
      } else if (0 <= value && value <= 5 && 0 <= popup_estimate_price) {
        window.rate = 'Standard Delivery Fee (0-5 mi): $0';
      }
      popup_estimate_result.innerHTML = window.rate;
    }
  }
}

// Setup custom analytics
function setupCustomAnalytics() {
  function handleClick(e) {
    if (e.target.closest('button').classList.contains('wishlisthero-product-in-wishlist')) {
      // In wishlisthero, removing product
      ga('send', 'event', 'All', 'click', 'Remove from wishlist', '1');
    } else {
      // In wishlisthero, adding product
      ga('send', 'event', 'All', 'click', 'Add to wishlist', '1');
    }
  }
  const wishlistButtons = document.querySelectorAll(".wishlist-hero-custom-button");
  wishlistButtons.forEach(function(item) {
    item.addEventListener("click", function(e) {
      handleClick(e);
    });
  });

  document.body.addEventListener("click", function (event) {
    const element = event.target.closest('#wishlisthero-product-page-button-container button');
    console.log('element', element);
    if (element) {
     handleClick(event);
    }
  });
};

// Setup discount
function setupDiscount() {
  const discount_code = this.getCookie('discount_code');
  if (!discount_code) return;

  const discount_right = document.querySelector('.discount__right');
  if (!discount_right) return;

  const cart_total = document.querySelector('.Cart__Total');
  if (!cart_total) return;

  const price = parseInt(cart_total.textContent.replace('$', '').replace(' USD', '').replace(',', ''));
  console.log('price', price);

  const new_price = price * 0.9;
  const discount_price = price * 0.1;

  const discount_price_string = '-$' + (discount_price).toLocaleString(
    'en-US',
    { minimumFractionDigits: 2 }
  );

  discount_right.innerHTML = discount_price_string

  const new_price_string = '$' + (new_price).toLocaleString(
    'en-US',
    { minimumFractionDigits: 2 }
  );
  
  cart_total.innerHTML = new_price_string;

  const discount__row = document.querySelector('.discount__row');
  if (!discount__row) return;
  discount__row.classList.toggle('hidden');
}

window.setupDiscount = setupDiscount;

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

